import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import HomeRedirect from '@/components/auth/HomeRedirect';
import { useAuth } from '@/context/AuthContext';

const AuthCallbackPage: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // The AuthContext will handle the OAuth callback automatically
    // This component just shows a loading state while that happens
  }, []);

  if (isLoading) {
    return (
      <div 
        className="flex min-h-screen min-w-screen items-center justify-center"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 50
        }}
      >
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Processing authentication...</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <HomeRedirect />;
  }

  // If not authenticated and not loading, redirect to login
  return <Navigate to="/login" replace />;
};

export default AuthCallbackPage;
